import AppRoutes from "../routes";

export const navigateByUserRole = (userData, navigate, redirectUrl) => {
  if (redirectUrl) {
    navigate(`/${redirectUrl}`);
  } else if (userData?.is_driver || userData?.isBiker) {
    navigate(AppRoutes.delivery);
  } else if (userData?.is_se || userData?.role === "SUPPORT_EXECUTIVE") {
    navigate("/support-executive");
  } else if (userData?.is_sm || userData?.role === "SUPPORT_MANAGER") {
    navigate(AppRoutes.support);
  } else if (userData?.role === "ADMIN") {
    navigate("/admin/dashboard");
  } else if (
    userData?.isRestaurantOwner ||
    userData?.is_vendor ||
    userData?.is_so
  ) {
    navigate(AppRoutes.restaurant_dashboard);
  } else {
    navigate(AppRoutes.home);
  }
};
